/*
Model defined for Maintaining Profile Responses. It can also be used for transferring model
*/

export class CompanyProfileModel {
    id: string;
    email: string;
    password: string;
    address: string;
    country: string;
    mobile: string;
    photo: string;
    logo: string;
    name: string;
    permissions: any;
    active: Boolean;
    gstNumber: string;
    panNumber: string;
    pinCode: string;
    partnerType: string;
    city: string;
    state: string;
    products: any[];
    actionEncashment: boolean;
    actionSell: boolean;
    showRateRange: boolean;

}

export class CompanyProfileUpdateModel {
    email: string;
    country: string;
    pinCode: string;
    panNumber: string;
    gstNumber: string;
    constructor(email: string, country: string, pinCode: string, panNumber: string, gstNumber: string) {
        this.email = email;
        this.country = country;
        this.pinCode = pinCode;
        this.panNumber = panNumber;
        this.gstNumber = gstNumber;
    }
}
export class KYCDocumentsModel {
    description: string;
    documentName: string;
    id: string;

}
export class UploadedDocsList {
    description: string;
    id: string;
    location: string;
    ownerId: string;
    ownerType: string;
    status: string;
    type: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/profile/CompanyProfileModel.ts